import {
  GET_PROJECT_PACKAGES,
  GET_PROJECT_PACKAGES_SUCCESS,
  GET_PROJECT_PACKAGES_FAIL,
  GET_ALL_PROJECT_PACKAGES,
  GET_ALL_PROJECT_PACKAGES_SUCCESS,
  GET_ALL_PROJECT_PACKAGES_FAIL,
  UPDATE_PROJECT_PACKAGE_INSTALLER,
  UPDATE_PROJECT_PACKAGE_INSTALLER_SUCCESS,
  UPDATE_PROJECT_PACKAGE_INSTALLER_FAIL,
  UPDATE_PROJECT_PACKAGE_SERIAL,
  UPDATE_PROJECT_PACKAGE_SERIAL_SUCCESS,
  UPDATE_PROJECT_PACKAGE_SERIAL_FAIL,
  RESET_PROJECT_PACKAGES_FLAG,
} from "./actionTypes"

const INIT_STATE = {
  projectPackages: [],
  allProjectPackages: [],
  loading: false,
  error: null,
  success: null,
  updateSerialLoading: false,
  updateSerialSuccess: null,
  updateSerialError: null,
}

const ProjectPackages = (state = INIT_STATE, action) => {
  switch (action.type) {
    // Get Project Packages
    case GET_PROJECT_PACKAGES:
      return {
        ...state,
        loading: true,
        error: null,
      }
    case GET_PROJECT_PACKAGES_SUCCESS:
      return {
        ...state,
        loading: false,
        projectPackages: action.payload,
      }
    case GET_PROJECT_PACKAGES_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    // Get All Project Packages (for Installer)
    case GET_ALL_PROJECT_PACKAGES:
      return {
        ...state,
        loading: true,
        error: null,
      }
    case GET_ALL_PROJECT_PACKAGES_SUCCESS:
      return {
        ...state,
        loading: false,
        allProjectPackages: action.payload,
      }
    case GET_ALL_PROJECT_PACKAGES_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    // Update Project Package Installer
    case UPDATE_PROJECT_PACKAGE_INSTALLER:
      return {
        ...state,
        loading: true,
        error: null,
      }
    case UPDATE_PROJECT_PACKAGE_INSTALLER_SUCCESS:
      return {
        ...state,
        loading: false,
        success: action.payload,
      }
    case UPDATE_PROJECT_PACKAGE_INSTALLER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    // Update Project Package Serial (for Installer)
    case UPDATE_PROJECT_PACKAGE_SERIAL:
      return {
        ...state,
        updateSerialLoading: true,
        updateSerialSuccess: null,
        updateSerialError: null,
      }
    case UPDATE_PROJECT_PACKAGE_SERIAL_SUCCESS:
      return {
        ...state,
        updateSerialLoading: false,
        updateSerialSuccess: action.payload,
        // Update the package in the list
        allProjectPackages: state.allProjectPackages.map(pkg =>
          pkg.id === action.payload.projectPackageId
            ? {
                ...pkg,
                serialNumber: action.payload.serialNumber,
                description: action.payload.description,
              }
            : pkg
        ),
      }
    case UPDATE_PROJECT_PACKAGE_SERIAL_FAIL:
      return {
        ...state,
        updateSerialLoading: false,
        updateSerialError: action.payload,
      }

    // Reset Flags
    case RESET_PROJECT_PACKAGES_FLAG:
      return {
        ...state,
        error: null,
        success: null,
        updateSerialSuccess: null,
        updateSerialError: null,
      }

    default:
      return state
  }
}

export default ProjectPackages

